// SPDX-FileCopyrightText: Copyright Orangebot, Inc. and Medplum contributors
// SPDX-License-Identifier: Apache-2.0
import { Box, Button, Group, Image, List, Paper, Text, Title } from '@mantine/core';
import type { JSX } from 'react';
import watchpatDevice from '../assets/watchpat-device.png';

interface HsatOrderBannerProps {
  onOrderNow: () => void;
}

export function HsatOrderBanner({ onOrderNow }: HsatOrderBannerProps): JSX.Element {
  return (
    <Paper
      p={20}
      radius={8}
      withBorder
      style={{
        borderColor: '#640040',
        borderWidth: 2,
        boxShadow:
          '0px 7px 7px 0px rgba(0,0,0,0.04), 0px 10px 15px 0px rgba(0,0,0,0.1), 0px 1px 3px 0px rgba(0,0,0,0.05)',
      }}
    >
      <Group gap={22} align="flex-start" wrap="nowrap">
        <Image
          src={watchpatDevice}
          alt="WatchPAT sleep test device"
          w={174}
          h={174}
          radius={8}
          style={{ flexShrink: 0, objectFit: 'cover' }}
        />
        <Box>
          <Title order={2} fz={32} fw={700} lh="40px" mb={15}>
            Order Your Sleep Test
          </Title>
          <List
            spacing={6}
            mb={15}
            icon={<Box w={6} h={6} mt={9} style={{ borderRadius: '50%', backgroundColor: '#212529', flexShrink: 0 }} />}
          >
            <List.Item>
              <Text size="md">Confirm Your Shipping Address</Text>
            </List.Item>
            <List.Item>
              <Text size="md">Add a Payment Method</Text>
            </List.Item>
          </List>
          <Button
            style={{ backgroundColor: '#640040', height: 50, paddingInline: 24, fontSize: 18, fontWeight: 600 }}
            onClick={onOrderNow}
          >
            Order Now
          </Button>
        </Box>
      </Group>
    </Paper>
  );
}
